import { render, staticRenderFns } from "./reg-wallet-3.vue?vue&type=template&id=3336ff5b&scoped=true&lang=pug&"
import script from "./reg-wallet-3.vue?vue&type=script&lang=js&"
export * from "./reg-wallet-3.vue?vue&type=script&lang=js&"
import style0 from "./reg-wallet-3.vue?vue&type=style&index=0&id=3336ff5b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3336ff5b",
  null
  
)

export default component.exports